var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.911774C5.625 0.911774 0 6.53677 0 13.4118C0 20.2868 5.625 25.9118 12.5 25.9118C19.375 25.9118 25 20.2868 25 13.4118C25 6.53677 19.375 0.911774 12.5 0.911774ZM12.5 4.66177C14.625 4.66177 16.25 6.28677 16.25 8.41177C16.25 10.5368 14.625 12.1618 12.5 12.1618C10.375 12.1618 8.75 10.5368 8.75 8.41177C8.75 6.28677 10.375 4.66177 12.5 4.66177ZM12.5 22.4118C9.375 22.4118 6.625 20.7868 5 18.4118C5 15.9118 10 14.5368 12.5 14.5368C15 14.5368 20 15.9118 20 18.4118C18.375 20.7868 15.625 22.4118 12.5 22.4118Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccount);
export default __webpack_public_path__ + "static/media/menu_account.ac4080f1.svg";
export { ForwardRef as ReactComponent };